"use strict";
var tooltip_directive_1 = require('./tooltip/tooltip.directive');
var tooltip_container_component_1 = require('./tooltip/tooltip-container.component');
var tooltip_directive_2 = require('./tooltip/tooltip.directive');
exports.TooltipDirective = tooltip_directive_2.TooltipDirective;
var tooltip_container_component_2 = require('./tooltip/tooltip-container.component');
exports.TooltipContainerComponent = tooltip_container_component_2.TooltipContainerComponent;
exports.TOOLTIP_DIRECTIVES = [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/tooltip.js
 ** module id = 834
 ** module chunks = 0
 **/